module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    "use strict";
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n  var i18n = require(\'@cdo/netsim/locale\');\n  var MessageGranularity = require(\'./NetSimConstants\').MessageGranularity;\n%>\n<div class="send-panel-packets"></div>\n<div class="panel-footer">\n  <div class="right-side-controls">\n    <% if (locals.level.showAddPacketButton) { %>\n      <span class="netsim-button netsim-button-secondary large-button" id="add-packet-button"><%= i18n.addPacket() %></span>\n    <% } %>\n    <% if (locals.level.messageGranularity === MessageGranularity.PACKETS) { %>\n      <span class="netsim-button large-button" id="send-button"><%= i18n.send() %></span>\n    <% } else if (locals.level.messageGranularity === MessageGranularity.BITS) { %>\n      <span class="netsim-button large-button" id="set-wire-button"><%= i18n.setWire() %></span>\n    <% } %>\n  </div>\n  <div class="packet-size"></div>\n</div>\n', __filename = "src/netsim/NetSimSendPanel.html.ejs";
    try {
        var __output = "";
        function __append(s) {
            if (s !== undefined && s !== null) __output += s;
        }
        var i18n = require("@cdo/netsim/locale");
        var MessageGranularity = require("./NetSimConstants").MessageGranularity;
        __line = 4;
        __append('\n<div class="send-panel-packets"></div>\n<div class="panel-footer">\n  <div class="right-side-controls">\n    ');
        __line = 8;
        if (locals.level.showAddPacketButton) {
            __append('\n      <span class="netsim-button netsim-button-secondary large-button" id="add-packet-button">');
            __line = 9;
            __append(escapeFn(i18n.addPacket()));
            __append("</span>\n    ");
            __line = 10;
        }
        __append("\n    ");
        __line = 11;
        if (locals.level.messageGranularity === MessageGranularity.PACKETS) {
            __append('\n      <span class="netsim-button large-button" id="send-button">');
            __line = 12;
            __append(escapeFn(i18n.send()));
            __append("</span>\n    ");
            __line = 13;
        } else if (locals.level.messageGranularity === MessageGranularity.BITS) {
            __append('\n      <span class="netsim-button large-button" id="set-wire-button">');
            __line = 14;
            __append(escapeFn(i18n.setWire()));
            __append("</span>\n    ");
            __line = 15;
        }
        __append('\n  </div>\n  <div class="packet-size"></div>\n</div>\n');
        __line = 19;
        return __output;
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}